import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, USER_ROLE} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {Messages, showMessage} from "@app/constants/Messages";
import JobSendRequestNoteContent from "@pages/candidate/detail/JobSendRequestNoteContent";
import Select from "react-select";
import {cloneDeep} from "lodash";
import {monthOptions, yearOptions} from "@app/utils/CommonUtils";
import {Provinces} from "@app/constants/Provinces";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {requestGetEmployeeList} from "@app/services/EmployeeService";
import {requestGetEmployerList} from "@app/services/EmployerService";
import {Link} from "react-router-dom";

const CandidateGeneral = (props) => {
    const [general, setGeneral] = useState({});
    const [isLoading, setIsLoading] = useState({});

    const {candidateId} = props

    const fetchCandidateGeneral = (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateGeneralDetail(canId).then((res) => {
            setGeneral(res.content)
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    useEffect(() => {
        console.log("fetchCandidateGeneral")
        if (candidateId) {
            fetchCandidateGeneral(candidateId)
        }
    }, [])


    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>General</h3>
                {/*<div className='card-tools'>*/}
                {/*    {isEditGeneral &&*/}
                {/*    <button type='button'*/}
                {/*            className='btn btn-default mr-2'*/}
                {/*            onClick={() => {*/}
                {/*                setIsEditGeneral(false);*/}
                {/*            }}*/}
                {/*            >*/}
                {/*        Cancel*/}
                {/*    </button>*/}
                {/*    }*/}
                {/*    {!isEditGeneral &&*/}
                {/*    <button type='button'*/}
                {/*            className='btn btn-default'*/}
                {/*            onClick={() => {*/}
                {/*                setIsEditGeneral(true);*/}
                {/*            }}*/}
                {/*            >*/}
                {/*        Edit*/}
                {/*    </button>*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}>Person ID: &nbsp;{candidateId}</label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>User
                        chủ: &nbsp;{general.created_user_name}</label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>Candidate Link: &nbsp;
                        <Link to={`/candidate/detail/${candidateId}`} target="_blank"
                              rel="noopener noreferrer">{`${window.location.origin}/candidate/detail/${candidateId}`}</Link>
                    </label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>Thời điểm
                        nhập: &nbsp; {general.created_date_time}</label>
                </div>
            </div>
        </div>
    )
}

export default CandidateGeneral;
